import { useCallback } from 'react';
import noop from 'lodash/noop';
import { Button } from '@cbhq/cds-web/buttons';
import { Pictogram } from '@cbhq/cds-web/illustrations';
import { VStack } from '@cbhq/cds-web/layout';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalProps } from '@cbhq/cds-web/overlays';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

type CancelSubscriptionSuccessModalProps = Partial<ModalProps>;

function CancelSubscriptionSuccessModal({ onRequestClose }: CancelSubscriptionSuccessModalProps) {
  const handleClose = useCallback(() => onRequestClose?.(), [onRequestClose]);
  return (
    <Modal hideDividers onRequestClose={onRequestClose || noop} visible>
      <ModalHeader />
      <ModalBody>
        <VStack
          gap={4}
          spacing={4}
          spacingVertical={10}
          justifyContent="center"
          alignItems="center"
        >
          <Pictogram name="checkmark" dimension="48x48" />
          <TextTitle3 as="p">Your subscription is canceled</TextTitle3>

          <TextBody as="p">You can reactivate your subscription at any time.</TextBody>
        </VStack>
      </ModalBody>
      <ModalFooter
        primaryAction={
          <Button type="submit" onPress={handleClose} testID="done">
            Done
          </Button>
        }
      />
    </Modal>
  );
}

export default CancelSubscriptionSuccessModal;
